module.exports = __webpack_public_path__ + "img/ventilador_danger.7235bea2.svg";